module.exports = __webpack_public_path__ + "img/course.0d4f967c.svg";